import React from "react";
import MessageBubble from "./MessageBubble";

const MessageList = ({ messages, isTyping, messagesEndRef }) => {
  return (
    <div className="flex flex-col gap-4 py-4">
      {messages.length === 0 && (
        <div className="text-center text-gray-500 text-sm my-8">
          Start a conversation by typing a message or selecting an option
        </div>
      )}
      {messages.map((message) => (
        <MessageBubble key={message.id} message={message} />
      ))}
      {isTyping && (
        <div className="flex justify-start">
          <div className="flex gap-2 max-w-[85%]">
            <img src="/naol.png" alt="NAOL" className="w-8 h-8 rounded-full object-cover flex-shrink-0" />
            <div className="flex flex-col">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-medium text-gray-800">NAOL</span>
              </div>
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-4 py-3">
                <div className="flex items-center gap-1">
                  <span className="typing-dot w-2 h-2 bg-gray-400 rounded-full" style={{ animationDelay: '0s' }}></span>
                  <span className="typing-dot w-2 h-2 bg-gray-400 rounded-full" style={{ animationDelay: '0.2s' }}></span>
                  <span className="typing-dot w-2 h-2 bg-gray-400 rounded-full" style={{ animationDelay: '0.4s' }}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div ref={messagesEndRef} className="h-4" />
    </div>
  );
};

export default MessageList;

